// Core
import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Components
import { Toggle } from "components/AtomsV2";
import { Icon } from "components/ShellV2";

function DeleteAccount({ onDelete }) {
  const [confirmed, setConfirmed] = useState(false);
  const { t } = useTranslation(["community"]);

  return (
    <div
      className="rec-card rec-card-pad"
      id="danger-info"
      style={{ borderColor: "var(--danger)" }}
    >
      <h3 className="rec-section-title" style={{ color: "var(--danger)" }}>
        <Icon name="warning" style={{ color: "var(--danger)" }} />
        {t("delete.title")}
      </h3>
      <p className="text-[13.5px] text-ink-2 leading-[1.6] mt-2 mb-4 max-w-[560px]">
        {t("delete.warning")}
      </p>
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <label htmlFor="confirm-delete" className="flex items-center gap-3 cursor-pointer">
          <Toggle
            id="confirm-delete"
            on={confirmed}
            onClick={() => setConfirmed((c) => !c)}
            ariaLabel={t("delete.confirm_label")}
          />
          <span className="leading-[1.3]">
            <span className="block text-[13.5px] font-semibold text-ink">
              {t("delete.confirm_label")}
            </span>
            <span className="text-[11.5px] text-ink-3">{t("delete.confirm_caption")}</span>
          </span>
        </label>
        <button
          type="button"
          className="rec-btn-danger"
          disabled={!confirmed}
          onClick={() => onDelete()}
        >
          <Icon name="delete_forever" />
          {t("delete.remove")}
        </button>
      </div>
    </div>
  );
}

DeleteAccount.propTypes = {
  onDelete: PropTypes.func.isRequired,
};

export default DeleteAccount;
